module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "teak-dune-abstract-hayman-0.662da46e.jpg";